import { Injectable } from '@angular/core';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  ApplicationQrveyActionTypes,
  ApplicationQrveyPageRequested,
  ApplicationQrveyPageLoaded,
  ApplicationQrveyActionToggleLoading,
  ApplicationQrveyPageToggleLoading,
  ThrowApplicationQrveyError,
  ApplicationQrveyPageCancelled,
} from '../_actions/application-qrvey.actions';
import { Router } from '@angular/router';
import { AuthService } from '../../auth';

@Injectable()
export class ApplicationQrveyEffects {
  showPageLoadingDistpatcher = new ApplicationQrveyPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new ApplicationQrveyPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new ApplicationQrveyActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new ApplicationQrveyActionToggleLoading({ isLoading: false });

  @Effect()
  loadApplicationQrveyPage$ = this.actions$.pipe(
    ofType<ApplicationQrveyPageRequested>(
      ApplicationQrveyActionTypes.ApplicationQrveyPageRequested,
    ),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.authService.getQRVEYApps(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0] && response[0].error) {
            if (response[0].status === 401) {
              this.authService.logout();
              return new ApplicationQrveyPageCancelled();
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new ApplicationQrveyPageCancelled();
            } else {
              this.store.dispatch(
                new ThrowApplicationQrveyError({ error: response[0].error.error }),
              );
              return new ApplicationQrveyPageCancelled();
            }
          } else {
            const result = response[0];
            return new ApplicationQrveyPageLoaded({
              applicationQrveys: result.data,
              totalCount: result.count,
              page: response[1],
            });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
  ) {}
}
